import { useDispatch } from 'react-redux'
import { setBienInEdition } from "./biensSlice"

import { PencilIcon } from '@heroicons/react/24/solid'

import { useBienContext } from './BienContext'

export default ({
  bienId, isArchived, isPendingAction, 
  onEditClick,
  title = "Modifier le bien"
}) => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  return ( 
    <div>
      <button 
        className="btn btn-sm btn-ghost btn-square hover:bg-primary-400" 
        title={title}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          dispatch(setBienInEdition(bien))
          onEditClick(bienId)
        }}
      >
        <PencilIcon className="h-5 w-5" />
      </button>
    </div>
  )
}